"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorStencil = exports.authorStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.authorStencilDefinition = {
    view: {
        label: 'Author',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: ['featured-media'],
                    },
                ],
            },
        ],
    },
    content: {
        'featured-media': {
            ...properties_1.featuredMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        standalone: properties_1.standalonePropertyDefinition,
        title: properties_1.titlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'redbull_com',
        'redbulletin',
        'speedweek',
    ],
    name: 'author',
};
const isAuthorStencil = (stencil) => {
    return stencil.name === exports.authorStencilDefinition.name;
};
exports.isAuthorStencil = isAuthorStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yLnN0ZW5jaWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RlbmNpbHMvYXV0aG9yLnN0ZW5jaWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsOENBSXNCO0FBRVQsUUFBQSx1QkFBdUIsR0FBRztJQUNyQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsUUFBUTtRQUNmLFFBQVEsRUFBRSxRQUFRO1FBQ2xCLEtBQUssRUFBRSxrQkFBa0I7UUFDekIsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxDQUFDLGdCQUFnQixDQUFDO1FBQzlCLFlBQVksRUFBRTtZQUNaO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLEtBQUssRUFBRSxDQUFDLE9BQU8sQ0FBQzthQUNqQjtZQUNEO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLFFBQVEsRUFBRTtvQkFDUjt3QkFDRSxJQUFJLEVBQUUsU0FBUzt3QkFDZixLQUFLLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQztxQkFDMUI7aUJBQ0Y7YUFDRjtTQUNGO0tBRUY7SUFDRCxPQUFPLEVBQUU7UUFDUCxnQkFBZ0IsRUFBRTtZQUNoQixHQUFHLDRDQUErQjtZQUNsQyxXQUFXLEVBQUU7Z0JBQ1g7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLFFBQVEsRUFBRSxLQUFLO2lCQUNoQjtnQkFDRDtvQkFDRSxJQUFJLEVBQUUsVUFBVTtvQkFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO2lCQUNwQjthQUNGO1NBQ0Y7UUFDRCxVQUFVLEVBQUUseUNBQTRCO1FBQ3hDLEtBQUssRUFBRSxvQ0FBdUI7S0FDL0I7SUFDRCxhQUFhLEVBQUUsRUFBRTtJQUNqQixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRTtRQUNOLGFBQWE7UUFDYixhQUFhO1FBQ2IsV0FBVztLQUNaO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZ0IsQ0FBQTtBQUl6QixNQUFNLGVBQWUsR0FBRyxDQUFDLE9BQW9CLEVBQTRCLEVBQUU7SUFDaEYsT0FBTyxPQUFPLENBQUMsSUFBSSxLQUFLLCtCQUF1QixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLGVBQWUsbUJBRTNCIn0=